export default "__VITE_ASSET__CHgKoGYK__"